document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.industry-certificates-box ');
    const readMoreButton = document.querySelector('#certificate-see-more-btn');
    const dataItemsValue = document.querySelector('.industry-certificates--wrapper')?.getAttribute('data-items');
    const itemsToShow = parseInt(dataItemsValue, 10) || 5; // Default to 5 items if data-items is not set
    let isExpanded = false; // To track the state of "See More" and "See Less"

    // Function to manage visibility of FAQ items
    function updateFaqVisibility() {
        let visibleCount = 0;
        faqItems.forEach(item => {
            if (visibleCount < itemsToShow || isExpanded) {
                item.style.display = 'flex'; // Show item
                visibleCount++;
            } else {
                item.style.display = 'none'; // Hide item
            }
        });
    }
    function updateReadMoreButton() {
        if (faqItems.length > itemsToShow) {
            readMoreButton.style.display = 'flex';
            const span = readMoreButton.querySelector('span');
            if (span) {
                span.textContent = isExpanded ? 'عرض أقل' : 'عرض المزيد'; // Update only the text inside the <span>
            }
        } else {
            readMoreButton.style.display = 'none';
        }
    }
    if (readMoreButton) {
        readMoreButton.addEventListener('click', () => {
            isExpanded = !isExpanded;
            updateFaqVisibility();
            updateReadMoreButton();
        });
    }
    updateFaqVisibility();
    updateReadMoreButton();
});